import { render, staticRenderFns } from "./ModalTabelaPorRegionalComponent.vue?vue&type=template&id=52bc6688"
import script from "./ModalTabelaPorRegionalComponent.vue?vue&type=script&lang=js"
export * from "./ModalTabelaPorRegionalComponent.vue?vue&type=script&lang=js"
import style0 from "./ModalTabelaPorRegionalComponent.vue?vue&type=style&index=0&id=52bc6688&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports